module.exports = "/_next/static/images/6dd3acea7072c2b0776aae0f0746d0c9-icon-1.svg";